import { render } from "./IconTrekMaterialAluminum.vue?vue&type=template&id=33cdb733"
import script from "./IconTrekMaterialAluminum.vue?vue&type=script&lang=js"
export * from "./IconTrekMaterialAluminum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__